import { Accordion, AccordionDetails, Button, Card, CardContent, Dialog, DialogActions, DialogContent, Grid2, IconButton, Typography } from '@mui/material'
import { PICTURE, PICTURE_TYPES } from 'components/file/constant/FileConstants'
import { getYear } from 'date-fns'
import PropTypes from 'prop-types'
import React, { useEffect, useMemo, useState } from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { nbPerPageLabelTiny, SANDRE } from 'referencial/constants/ReferencialConstants'
import useBoolean from 'utils/customHook/useBoolean'
import useSandreList from 'utils/customHook/useSandreList'
import { getDocumentTypeIcon, getFileExtension, getFileName, getFileNatureLabel, getFileType, getFormatedFileName } from 'utils/FileUtils'
import { getI18nTitleDataLength, searchAllCharacters } from 'utils/StringUtil'
import i18n from 'simple-react-i18n'
import { groupBy, isNil, keys, orderBy, uniqBy } from 'lodash'
import EditIcon from '@mui/icons-material/Edit'
import CancelIcon from '@mui/icons-material/Cancel'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'
import Input from 'components/forms/Input'
import Select from 'components/forms/Select'
import SimpleTabList from 'components/list/SimpleTabList'
import ProgressBar from 'components/progress/ProgressBar'
import { getDate, getYearOrString } from 'utils/DateUtil'
import { AccordionTitle } from 'components/styled/Accordions'
import Fancybox from 'components/fancybox/Fancybox'
import useActions from 'utils/customHook/useActions'
import { getStationArrowNav } from 'utils/ActionUtils'
import { push } from '@lagunovsky/redux-react-router'
import { getLinks, getStationTypeCodeFromType } from 'utils/StationUtils'
import DtoProductionUnit from 'productionUnit/dto/DtoProductionUnit'
import DtoDistributionUnit from 'distributionUnit/dto/DtoDistributionUnit'
import DtoQualitometer from 'quality/dto/DtoQualitometer'
import DtoPiezometer from 'piezometry/dto/DtoPiezometer'
import DtoHydrometricStation from 'hydrometry/dto/DtoHydrometricStation'
import DtoInstallation from 'installation/dto/installation/DtoInstallation'
import DtoQualitometerLight from 'quality/dto/DtoQualitometerLight'
import DtoPiezometerLight from 'piezometry/dto/DtoPiezometerLight'
import PluviometerDto from 'pluviometry/dto/PluviometerDto'
import ResourceDto from 'resource/dto/ResourceDto'
import ConfirmModal from 'components/modal/ConfirmModal'
import WaitAction from 'wait/WaitAction'
import StationAction from 'station/actions/StationAction'
import moment from 'moment'
import ToastrAction from 'toastr/actions/ToastrAction'
import { DefaultDialogTitle } from 'components/styled/Dialog'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'
import { CardTable } from 'components/datatable/NewTable'
import { getSiteUrl } from 'utils/mapUtils/SiteTypes'
import { STATION_NAME_ASSOCIATION } from 'station/constants/StationConstants'
import Checkbox from 'components/forms/Checkbox'
import DtoFile from 'components/file/dto/DtoFile'

const DATE = 'date'
const FILE = 'file'
const ACTIVE = 'active'

const getFileInfo = (file = {}) => {
    if (file.fileType === PICTURE) {
        return {
            sandreConstant: SANDRE.TYPE_PHOTO,
            fileTypeName: i18n.pictureType,
            image: <img src={file.url} style={{ maxWidth: '100%', height: '120px', borderRadius: '4px', objectFit: 'contain' }} />,
        }
    }
    const ext = getFileExtension(file.name)
    return {
        sandreConstant: SANDRE.TYPE_DOCUMENT,
        fileTypeName: i18n.documentType,
        image: <img src={getDocumentTypeIcon(ext)} style={{ height: '120px', padding: '20' }} />,
    }
}

const FilterFields = ({
    defaultFilter = {},
    onValidate = () => {},
    files = [],
}) => {
    const typePictures = useSandreList(SANDRE.TYPE_PHOTO)
    const typeDocuments = useSandreList(SANDRE.TYPE_DOCUMENT)

    const [searchValue, setSearchValue] = useState(defaultFilter.searchValue)
    const [extension, setExtension] = useState(defaultFilter.extension)
    const [naturePicture, setNaturePicture] = useState(defaultFilter.naturePicture)
    const [natureDocument, setNatureDocument] = useState(defaultFilter.natureDocument)
    const [year, setYear] = useState(defaultFilter.year)
    const [active, setActive] = useState(defaultFilter.active)

    const activeOptions = useMemo(() => [
        { name: i18n.active, code: '1' },
        { name: i18n.inactive, code: '0' },
    ], [])

    const orderedTypePictures = useMemo(() => orderBy(typePictures, 'code'), [typePictures])
    const orderedTypeDocuments = useMemo(() => orderBy(typeDocuments, 'code'), [typeDocuments])

    const onSearch = () => {
        onValidate({
            searchValue,
            extension,
            naturePicture,
            natureDocument,
            year,
            active,
        })
    }

    const onReset = () => {
        setSearchValue('')
        setExtension()
        setNaturePicture()
        setNatureDocument()
        setYear()
        setActive()

        onValidate({ searchValue: '' })
    }

    const extensions = useMemo(() => uniqBy(files.map(f => {
        const ext = getFileExtension(f.name)
        return { id: ext, label: ext }
    }), 'id'), [files])

    const years = useMemo(() => {
        const formattedYears = files.map(f => {
            if (isNil(f.date) || isNaN(f.date)) return { id: -1, label: i18n.unknownDate }
            const y = getYear(f.date)
            return { id: y, label: `${y}` }
        })
        return orderBy(uniqBy(formattedYears, 'id'), 'id')
    }, [files])

    return (
        <Card>
            <CardContent>
                <Grid2 container spacing={1}>
                    <Grid2 size={2}>
                        <Input
                            title={i18n.search}
                            value={searchValue}
                            onChange={setSearchValue}
                            onEnterKeyPress={onSearch}
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <Select
                            label={i18n.extensions}
                            options={extensions}
                            value={extension}
                            onChange={setExtension}
                            keyValue='name'
                            keyLabel='name'
                            nullLabel='&nbsp;'
                            noSort
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <Select
                            label={i18n.pictureType}
                            options={orderedTypePictures}
                            value={naturePicture}
                            onChange={setNaturePicture}
                            keyValue='name'
                            keyLabel='name'
                            nullLabel='&nbsp;'
                            noSort
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <Select
                            label={i18n.documentType}
                            options={orderedTypeDocuments}
                            value={natureDocument}
                            onChange={setNatureDocument}
                            keyValue='name'
                            keyLabel='name'
                            nullLabel='&nbsp;'
                            noSort
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <Select
                            label={i18n.year}
                            options={years}
                            value={year}
                            onChange={setYear}
                            nullLabel='&nbsp;'
                            noSort
                        />
                    </Grid2>
                    <Grid2 size={2}>
                        <Select
                            label={i18n.active}
                            options={activeOptions}
                            value={active}
                            onChange={setActive}
                            nullLabel='&nbsp;'
                        />
                    </Grid2>
                    <Grid2 size={1} offset={10}>
                        <Button
                            onClick={onReset}
                            variant='outlined'
                            color='primary'
                            fullWidth
                        >
                            {i18n.reinit}
                        </Button>
                    </Grid2>
                    <Grid2 size={1}>
                        <Button
                            onClick={onSearch}
                            variant='contained'
                            color='primary'
                            fullWidth
                        >
                            {i18n.search}
                        </Button>
                    </Grid2>
                </Grid2>
            </CardContent>
        </Card>
    )
}

FilterFields.propTypes = {
    defaultFilter: PropTypes.shape({}),
    onValidate: PropTypes.func,
    files: PropTypes.arrayOf(PropTypes.instanceOf(DtoFile)),
}

const ImportDialog = ({
    isOpen = false,
    onClose = () => {},
    files = [],
    station,
    stationType,
}) => {
    const dispatch = useDispatch()
    const {
        associatedSites,
    } = useSelector(store => ({
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    const [name, setName] = useState()
    const [content, setContent] = useState()

    const [fileType, setFileType] = useState(0)
    const [date, setDate] = useState()
    const [samplePoint, setSamplePoint] = useState()
    const [active, setActive] = useState()
    const [shared, setShared] = useState()

    useEffect(() => {
        if (isOpen) return

        setName()
        setContent()
        setFileType(0)
        setDate()
        setActive()
    }, [isOpen])

    const onImportFile = (e) => {
        const reader = new FileReader()
        const file = e.target.files[0]
        setName(file.name)
        reader.onload = upload => setContent(upload.target.result)
        reader.readAsDataURL(file)
    }

    const { sandreCode, title } = getFileType(content)
    const fileTypes = useSandreList(sandreCode)

    const saveFile = () => {
        const now = moment().valueOf()
        const activeInt = active ? 1 : 0
        const ft = fileTypes.find(t => t.code === fileType)
        const point = station.link_samplePoints.find(sp => sp.idPoint === samplePoint)
        const formattedName = getFormatedFileName(station.code, activeInt, getFileName(name), getFileExtension(name), ft.mnemonique || ft.name, date ?? now, stationType, shared, point)
        if (files.some(f => f.name === formattedName)) {
            dispatch(ToastrAction.warning(i18n.nameAlreadyExist))
            return
        }

        const formattedFile = {
            stationType: getStationTypeCodeFromType(stationType),
            stationId: station.id,
            path: '',
            content,
            fileType,
            active: activeInt,
            date: date ?? now,
            name: formattedName,
        }

        const type = content.includes(PICTURE_TYPES.IMAGE) ? 'picture' : 'doc'

        dispatch(WaitAction.waitStart())
        dispatch(StationAction.addStationFile(formattedFile, type)).then(() => {
            Promise.all([
                dispatch(StationAction.fetchFiles(station.code, stationType?.toUpperCase())),
                dispatch(StationAction.fetchPictures(station.code, stationType?.toUpperCase())),
            ]).finally(() => dispatch(WaitAction.waitStop()))
        }).finally(onClose)
    }

    const formattedAssociatedSites = useMemo(() => {
        return associatedSites.filter(as => as.code === as.stationLinkedCode).map(d => ({
            stationType: (
                <img
                    src={getSiteUrl(STATION_NAME_ASSOCIATION[d.typeName])}
                    style={{ maxHeight: '30px' }}
                />
            ),
            code: d.code,
            name: d.stationLinkedName,
        }))
    }, [associatedSites])

    const samplePoints = useMemo(() => {
        if (stationType !== 'quality') return []
        return station.link_samplePoints?.filter(sp => !isNil(sp.identifiant) || !isNil(sp.name)).map(sp => ({
            id: sp.idPoint,
            label: `${isNil(sp.identifiant) ? '' : `[${sp.identifiant}] `}${sp.name}${isNil(sp.startDate) ? '' : ` (${getDate(sp.startDate)})`}`,
        }))
    }, [station, stationType])

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth='lg'
        >
            <DefaultDialogTitle
                title={i18n.importFile}
                onClose={onClose}
            />
            <DialogContent>
                <Card>
                    <CardContent>
                        <Grid2 container rowSpacing={0.5} columnSpacing={1} alignItems='center'>
                            <Grid2 size='auto'>
                                <Button
                                    variant='contained'
                                    color='primary'
                                    component='label'
                                    fullWidth
                                >
                                    <span>{i18n.chooseFile}</span>
                                    <input
                                        type='file'
                                        hidden
                                        onChange={onImportFile}
                                    />
                                </Button>
                            </Grid2>
                            <Grid2 size='grow'>
                                <Input value={name ?? i18n.pleaseSelectFile} style={{ marginTop: '-0.5rem' }} disabled/>
                            </Grid2>
                            {!isNil(name) && (
                                <>
                                    <Grid2 size={12}>
                                        <Select
                                            label={title}
                                            options={fileTypes}
                                            value={fileType}
                                            onChange={setFileType}
                                            noNullValue
                                            noSort
                                            keyLabel='name'
                                        />
                                    </Grid2>
                                    <Grid2 size={3}>
                                        <SimpleDatePicker
                                            label={i18n.date}
                                            value={date}
                                            onChange={setDate}
                                        />
                                    </Grid2>
                                    <Grid2 size={3}>
                                        <Checkbox
                                            onChange={setActive}
                                            checked={active}
                                            label={i18n.active}
                                        />
                                    </Grid2>
                                    <Grid2 size={6}>
                                        {stationType === 'quality' && (
                                            <Select
                                                label={i18n.samplePoint}
                                                options={samplePoints}
                                                value={samplePoint}
                                                onChange={setSamplePoint}
                                                noSort
                                            />
                                        )}
                                    </Grid2>
                                    <Grid2 size={8}>
                                        <CardTable
                                            title={i18n.sharedWithOtherStations}
                                            rows={formattedAssociatedSites}
                                            headers={['stationType', 'code', 'name']}
                                            rowsPerPageOptions={nbPerPageLabelTiny}
                                        />
                                    </Grid2>
                                    <Grid2 size={4}>
                                        <Checkbox
                                            onChange={setShared}
                                            checked={shared}
                                            label={i18n.sharedWithOtherStations}
                                        />
                                    </Grid2>
                                </>
                            )}
                        </Grid2>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={saveFile}
                    variant='contained'
                    color='primary'
                    disabled={isNil(content) || isNil(name) || isNil(fileType)}
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

ImportDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    files: PropTypes.arrayOf(PropTypes.instanceOf(DtoFile)),
    station: PropTypes.oneOfType([
        PropTypes.instanceOf(DtoQualitometer),
        PropTypes.instanceOf(DtoPiezometer),
        PropTypes.instanceOf(DtoHydrometricStation),
        PropTypes.instanceOf(PluviometerDto),
        PropTypes.instanceOf(DtoInstallation),
        PropTypes.instanceOf(DtoDistributionUnit),
        PropTypes.instanceOf(DtoProductionUnit),
        PropTypes.instanceOf(ResourceDto),
    ]),
    stationType: PropTypes.string,
    loadFiles: PropTypes.func,
}

const UpdateFileDialog = ({
    isOpen = false,
    onClose = () => {},

    fileName,
    files = [],
    station,
    stationType,
}) => {
    const dispatch = useDispatch()
    const {
        associatedSites,
    } = useSelector(store => ({
        associatedSites: store.StationReducer.associatedSites,
    }), shallowEqual)

    const [name, setName] = useState()
    const [fileType, setFileType] = useState(0)
    const [date, setDate] = useState()
    const [samplePoint, setSamplePoint] = useState()
    const [active, setActive] = useState()
    const [shared, setShared] = useState()

    const file = useMemo(() => files.find(f => f.name === fileName), [files, fileName])

    const {
        sandreConstant,
        fileTypeName,
    } = getFileInfo(file)

    const fileTypes = useSandreList(sandreConstant)

    useEffect(() => {
        if (isNil(file)) return

        const ft = fileTypes?.find(t => t.mnemonique === file.type || t.name === file.type)?.code

        setName(file.shortName)
        setFileType(ft)
        setDate(file.date)
        setSamplePoint((station.link_samplePoints || station.link_pointPrels)?.find(sp => sp.identifiant === file.identifiantPoint && sp.startDate === file.startDatePoint)?.idPoint)
        setActive(file.active === '1')
        setShared(file.shared)
    }, [file])

    const saveFile = () => {
        const now = moment().valueOf()
        const activeInt = active ? 1 : 0
        const ft = fileTypes.find(t => t.code === fileType)
        const point = (station.link_samplePoints || station.link_pointPrels)?.find(sp => sp.idPoint === samplePoint)
        const formattedName = getFormatedFileName(station.code, activeInt, name, getFileExtension(file.name), ft.mnemonique || ft.name, date ?? now, stationType, file.shared, point)
        if (file.name !== formattedName && files.some(f => f.name === formattedName)) {
            dispatch(ToastrAction.warning(i18n.nameAlreadyExist))
            return
        }

        const formattedFile = {
            ...file,
            newName: formattedName,
        }

        dispatch(WaitAction.waitStart())
        dispatch(StationAction.updateFile(formattedFile)).then(() => {
            Promise.all([
                dispatch(StationAction.fetchFiles(station.code, stationType?.toUpperCase())),
                dispatch(StationAction.fetchPictures(station.code, stationType?.toUpperCase())),
            ]).finally(() => dispatch(WaitAction.waitStop()))
        }).finally(onClose)
    }

    const formattedAssociatedSites = useMemo(() => {
        return associatedSites.filter(as => as.code === as.stationLinkedCode).map(d => ({
            stationType: (
                <img
                    src={getSiteUrl(STATION_NAME_ASSOCIATION[d.typeName])}
                    style={{ maxHeight: '30px' }}
                />
            ),
            code: d.code,
            name: d.stationLinkedName,
        }))
    }, [associatedSites])

    const samplePoints = useMemo(() => {
        if (stationType !== 'quality') return []
        return station.link_samplePoints?.filter(sp => !isNil(sp.identifiant) || !isNil(sp.name)).map(sp => ({
            id: sp.idPoint,
            label: `${isNil(sp.identifiant) ? '' : `[${sp.identifiant}] `}${sp.name}${isNil(sp.startDate) ? '' : ` (${getDate(sp.startDate)})`}`,
        }))
    }, [station, stationType])

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth='lg'
        >
            <DefaultDialogTitle
                title={`${i18n.update}: ${file?.shortName ?? i18n.unknown}.${getFileExtension(file?.name)}`}
                onClose={onClose}
            />
            <DialogContent>
                <Card>
                    <CardContent sx={{ overflow: 'hidden' }}>
                        <Grid2 container rowSpacing={0.5} columnSpacing={1} alignItems='center'>
                            <Grid2 size={12}>
                                <Input
                                    title={i18n.name}
                                    value={name}
                                    onChange={setName}
                                />
                            </Grid2>
                            <Grid2 size={12}>
                                <Select
                                    label={fileTypeName}
                                    options={fileTypes}
                                    value={fileType}
                                    onChange={setFileType}
                                    noNullValue
                                    noSort
                                    keyLabel='name'
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <SimpleDatePicker
                                    label={i18n.date}
                                    value={date}
                                    onChange={setDate}
                                />
                            </Grid2>
                            <Grid2 size={3}>
                                <Checkbox
                                    onChange={setActive}
                                    checked={active}
                                    label={i18n.active}
                                />
                            </Grid2>
                            <Grid2 size={6}>
                                {stationType === 'quality' && (
                                    <Select
                                        label={i18n.samplePoint}
                                        options={samplePoints}
                                        value={samplePoint}
                                        onChange={setSamplePoint}
                                        noSort
                                    />
                                )}
                            </Grid2>
                            <Grid2 size={8}>
                                <CardTable
                                    title={i18n.sharedWithOtherStations}
                                    rows={formattedAssociatedSites}
                                    headers={['stationType', 'code', 'name']}
                                    rowsPerPageOptions={nbPerPageLabelTiny}
                                />
                            </Grid2>
                            <Grid2 size={4}>
                                <Checkbox
                                    onChange={setShared}
                                    checked={shared}
                                    label={i18n.sharedWithOtherStations}
                                />
                            </Grid2>
                        </Grid2>
                    </CardContent>
                </Card>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={saveFile}
                    variant='contained'
                    color='primary'
                    disabled={isNil(name) || isNil(fileType)}
                >
                    {i18n.validate}
                </Button>
            </DialogActions>
        </Dialog>
    )
}

UpdateFileDialog.propTypes = {
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    fileName: PropTypes.string,
    files: PropTypes.arrayOf(PropTypes.instanceOf(DtoFile)),
    station: PropTypes.oneOfType([
        PropTypes.instanceOf(DtoQualitometer),
        PropTypes.instanceOf(DtoPiezometer),
        PropTypes.instanceOf(DtoHydrometricStation),
        PropTypes.instanceOf(PluviometerDto),
        PropTypes.instanceOf(DtoInstallation),
        PropTypes.instanceOf(DtoDistributionUnit),
        PropTypes.instanceOf(DtoProductionUnit),
        PropTypes.instanceOf(ResourceDto),
    ]),
    stationType: PropTypes.string,
}

const FileCard = ({
    file = {},
    isEditMode = false,
    stationCode = '',

    onUpdate,
    onDelete,
}) => {
    const displayName = file.isAllDataName && stationCode === file.stationCode ? file.shortName : getFileName(file.name)

    const {
        sandreConstant,
        image,
    } = getFileInfo(file)

    const fileNatures = useSandreList(sandreConstant)

    return (
        <Fancybox>
            <a href={isEditMode ? undefined : file.url} target='_blank' data-fancybox={file.fileType == PICTURE && !isEditMode ? 'images' : undefined} data-caption={displayName}>
                <Card>
                    <CardContent>
                        <Grid2 container spacing={2} alignItems='center'>
                            <Grid2 size={3} textAlign='center'>
                                {image}
                            </Grid2>
                            <Grid2 container size={9} rowSpacing={0} columnSpacing={0.2}>
                                <Grid2 size='grow'>
                                    <Typography
                                        style={{
                                            whiteSpace: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                        }}
                                        fontWeight='bold'
                                        variant='subtitle1'
                                        color='text.secondary'
                                        component='div'
                                    >
                                        {displayName}
                                    </Typography>
                                </Grid2>
                                {isEditMode && (
                                    <>
                                        <Grid2 size='auto'>
                                            <IconButton
                                                color='primary'
                                                size='small'
                                                onClick={() => onUpdate(file.name)}
                                            >
                                                <EditIcon />
                                            </IconButton>
                                        </Grid2>
                                        <Grid2 size='auto'>
                                            <IconButton
                                                color='primary'
                                                size='small'
                                                onClick={() => onDelete(file.name)}
                                            >
                                                <CancelIcon />
                                            </IconButton>
                                        </Grid2>
                                    </>
                                )}
                                <Grid2 size={12}>
                                    <Typography variant='subtitle1' color='text.secondary' component='div'>
                                        {i18n.type} : {getFileExtension(file.name)}
                                    </Typography>
                                </Grid2>
                                <Grid2 size={12}>
                                    <Typography variant='subtitle1' color='text.secondary' component='div'>
                                        {i18n.nature} : {getFileNatureLabel(file, fileNatures)}
                                    </Typography>
                                </Grid2>
                                <Grid2 size={12}>
                                    <Typography variant='subtitle1' color='text.secondary' component='div'>
                                        {i18n.date} : {getDate(file.date)}
                                    </Typography>
                                </Grid2>
                                <Grid2 size={6} display='flex' alignItems='center'>
                                    <Typography variant='subtitle1' color='text.secondary' component='div'>
                                        {i18n.active} :
                                    </Typography>
                                    {file.active === '1' ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                                </Grid2>
                                <Grid2 size={6} display='flex' alignItems='center'>
                                    <Typography variant='subtitle1' color='text.secondary' component='div'>
                                        {i18n.shared} :
                                    </Typography>
                                    {file.shared === '1' ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
                                </Grid2>
                            </Grid2>
                        </Grid2>
                    </CardContent>
                </Card>
            </a>
        </Fancybox>
    )
}

FileCard.propTypes = {
    file: PropTypes.shape({}),
    isEditMode: PropTypes.bool,
    stationCode: PropTypes.string,
    onUpdate: PropTypes.func,
    onDelete: PropTypes.func,
}

const groupFiles = (files, group, typePictures, typeDocuments) => {
    switch (group) {
        case FILE: return groupBy(files, f => {
            const listTypes = f.fileType === PICTURE ? typePictures : typeDocuments
            return listTypes.find(t => t.mnemonique === f.type || t.name === f.type)?.name
        })
        case ACTIVE: return groupBy(files, file => file.active === '1' ? i18n.active : i18n.inactive)
        case DATE:
        default: return groupBy(files, file => getYearOrString(file.date, i18n.thisYear, ''))
    }
}

const PicturesApp = ({
    stations = [],
    station,
    stationType = '',
}) => {
    const dispatch = useDispatch()

    const {
        pictures,
        documents,

        // for links
        hydrogeologicalEntities,
        distributionUnitLink,
        installation,
        stationWatermass,
    } = useSelector(store => ({
        pictures: store.StationReducer.pictures,
        documents: store.StationReducer.files,

        // for links
        hydrogeologicalEntities: store.HydrogeologicalEntityReducer.hydrogeologicalEntities,
        distributionUnitLink: store.DistributionUnitReducer.distributionUnitLink,
        installation: store.InstallationReducer.installation,
        stationWatermass: store.StationReducer.stationWatermass,
    }), shallowEqual)

    const typePictures = useSandreList(SANDRE.TYPE_PHOTO)
    const typeDocuments = useSandreList(SANDRE.TYPE_DOCUMENT)

    const [filter, setFilter] = useState({ searchValue: '' })

    const [selectedFile, setSelectedFile] = useState()

    const {
        value: isEditMode,
        setTrue: onEdit,
        setFalse: onRead,
    } = useBoolean(false)
    const {
        value: isNewFileOpen,
        setTrue: onNewFileOpen,
        setFalse: onNewFileClose,
    } = useBoolean(false)
    const {
        value: isUpdateFileOpen,
        setTrue: onUpdateFileOpen,
        setFalse: onUpdateFileClose,
    } = useBoolean(false)
    const {
        value: isConfirmOpen,
        setTrue: onConfirmOpen,
        setFalse: onConfirmClose,
    } = useBoolean(false)

    const [isLoaded, setLoaded] = useState(false)

    useEffect(() => {
        if (station?.code?.replaceAll(' ', '') !== '') {
            Promise.all([
                dispatch(StationAction.fetchFiles(station.code, stationType?.toUpperCase())),
                dispatch(StationAction.fetchPictures(station.code, stationType?.toUpperCase())),
            ]).finally(() => setLoaded(true))
        } else {
            dispatch(ToastrAction.warning(i18n.noFileOrPictureWithoutCode))
            setLoaded(true)
        }
    }, [dispatch, station.code, stationType])

    const files = useMemo(() => [...documents, ...pictures], [documents, pictures])

    useActions(() => {
        const objLink = {
            stationTypes: [stationType],
            hydrogeologicalEntities,
            distributionUnitLink,
            installation,
            stationWatermass,
        }
        const baseActions = {
            links: getLinks(station, objLink),
            arrowNav: getStationArrowNav(stationType, stations, station?.id, s => dispatch(push(`/station/${stationType}/${s.id}/picture`))),
        }
        if (isEditMode) {
            return {
                cancel: onRead,
                new: onNewFileOpen,
                ...baseActions,
            }
        }
        return {
            edit: onEdit,
            ...baseActions,
        }
    }, [isEditMode, stations, station, stationType, hydrogeologicalEntities, distributionUnitLink, installation, stationWatermass])

    const filteredFiles = useMemo(() => {
        const {
            searchValue,
            extension,
            naturePicture,
            natureDocument,
            year,
            active,
        } = filter

        const search = searchAllCharacters(searchValue)
        const typePicture = typePictures.find(t => t.mnemonique === naturePicture || t.name === naturePicture)
        const typeDocument = typeDocuments.find(t => t.mnemonique === natureDocument || t.name === natureDocument)

        const filterByName = search ? files.filter(f => searchAllCharacters(f.shortName).includes(search)) : files
        const filterByActive = active ? filterByName.filter(f => f.active === active) : filterByName
        const filterByYear = year ? filterByActive.filter(f => getYear(f.date) === year) : filterByActive
        const filterByExtension = extension ? filterByYear.filter(f => getFileExtension(f.name) === extension) : filterByYear
        const filterByNaturePicture = naturePicture ? filterByExtension.filter(f => {
            return f.fileType !== PICTURE || typePicture.mnemonique === f.type || typePicture.name === f.type
        }) : filterByExtension
        const filterByNatureDocument = natureDocument ? filterByNaturePicture.filter(f => {
            return f.fileType === PICTURE || typeDocument.mnemonique === f.type || typeDocument.name === f.type
        }) : filterByNaturePicture
        return filterByNatureDocument
    }, [filter, files, typePictures, typeDocuments])

    return (
        <Grid2 container style={{ padding: '5 10 100 10' }} spacing={1} direction='column'>
            <Grid2>
                <FilterFields
                    defaultFilter={filter}
                    onValidate={setFilter}
                    files={files}
                />
            </Grid2>
            <Grid2>
                <SimpleTabList
                    defaultTab={DATE}
                    tabs={[
                        {
                            constant: DATE,
                            label: i18n.date,
                            icon: 'insert_invitation',
                        },
                        {
                            constant: FILE,
                            label: i18n.files,
                            icon: 'insert_drive_file',
                        },
                        {
                            constant: ACTIVE,
                            label: i18n.active,
                            icon: 'remove_red_eye',
                        },
                    ]}
                >
                    {
                        tab => {
                            if (!isLoaded) {
                                return (
                                    <div style={{ padding: '10px' }}>
                                        <ProgressBar indeterminate withMessage />
                                    </div>
                                )
                            }
                            if (filteredFiles.length === 0) {
                                return (
                                    <div className='center font-size-20'>{i18n.noResults}</div>
                                )
                            }
                            const groups = groupFiles(filteredFiles, tab, typePictures, typeDocuments)
                            return (
                                <Grid2 container spacing={1} padding='10px'>
                                    {keys(groups).reverse().map((key, i) => (
                                        <Grid2 key={key} size={12}>
                                            <Accordion defaultExpanded={i === 0}>
                                                <AccordionTitle
                                                    title={`${key} (${groups[key].length} ${getI18nTitleDataLength(i18n.element, i18n.elements, groups[key].length)})`}
                                                />
                                                <AccordionDetails>
                                                    <Grid2 container spacing={1}>
                                                        {groups[key].map(f => (
                                                            <Grid2 key={f.name} size={3}>
                                                                <FileCard
                                                                    file={f}
                                                                    isEditMode={isEditMode}
                                                                    stationCode={station?.code}
                                                                    onUpdate={name => {
                                                                        setSelectedFile(name)
                                                                        onUpdateFileOpen()
                                                                    }}
                                                                    onDelete={name => {
                                                                        setSelectedFile(name)
                                                                        onConfirmOpen()
                                                                    }}
                                                                />
                                                            </Grid2>
                                                        ))}
                                                    </Grid2>
                                                </AccordionDetails>
                                            </Accordion>
                                        </Grid2>
                                    ))}
                                </Grid2>
                            )
                        }
                    }
                </SimpleTabList>
                <ImportDialog
                    isOpen={isNewFileOpen}
                    onClose={onNewFileClose}
                    files={files}
                    station={station}
                    stationType={stationType}
                />
                <UpdateFileDialog
                    isOpen={isUpdateFileOpen}
                    onClose={onUpdateFileClose}
                    fileName={selectedFile}
                    files={files}
                    station={station}
                    stationType={stationType}
                />
                <ConfirmModal
                    isOpen={isConfirmOpen}
                    title={i18n.deletingConfirmation}
                    subTitle={selectedFile}
                    onClose={onConfirmClose}
                    onValidate={() => {
                        const file = files.find(f => f.name === selectedFile)
                        dispatch(WaitAction.waitStart())
                        dispatch(StationAction.deleteFile(file)).then(() => {
                            Promise.all([
                                dispatch(StationAction.fetchFiles(station.code, stationType?.toUpperCase())),
                                dispatch(StationAction.fetchPictures(station.code, stationType?.toUpperCase())),
                            ]).finally(() => dispatch(WaitAction.waitStop()))
                        }).finally(onConfirmClose)
                    }}
                />
            </Grid2>
        </Grid2>
    )
}

PicturesApp.propTypes = {
    stations: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.instanceOf(DtoQualitometerLight)),
        PropTypes.arrayOf(PropTypes.instanceOf(DtoPiezometerLight)),
        PropTypes.arrayOf(PropTypes.instanceOf(DtoHydrometricStation)),
        PropTypes.arrayOf(PropTypes.instanceOf(PluviometerDto)),
        PropTypes.arrayOf(PropTypes.instanceOf(DtoInstallation)),
        PropTypes.arrayOf(PropTypes.instanceOf(DtoDistributionUnit)),
        PropTypes.arrayOf(PropTypes.instanceOf(DtoProductionUnit)),
        PropTypes.arrayOf(PropTypes.instanceOf(ResourceDto)),
    ]),
    station: PropTypes.oneOfType([
        PropTypes.instanceOf(DtoQualitometer),
        PropTypes.instanceOf(DtoPiezometer),
        PropTypes.instanceOf(DtoHydrometricStation),
        PropTypes.instanceOf(PluviometerDto),
        PropTypes.instanceOf(DtoInstallation),
        PropTypes.instanceOf(DtoDistributionUnit),
        PropTypes.instanceOf(DtoProductionUnit),
        PropTypes.instanceOf(ResourceDto),
    ]),
    stationType: PropTypes.string,
}

export default PicturesApp